<template>
    <el-container style="width:100%">
        <el-header style="height:7%">
            <el-form>
                <el-row>
                    <el-col :span="24">
                        <el-form-item style="margin-left:5px;">
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.MY_WORK_FLOW') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click="btnAdd">{{ $t('pgCommon.START_WORK_FLOW') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                ref="leaveBill"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :rowKey="rowKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-leaveBill
                v-if="dialogLeaveBillVisible"
                :isAddData="isAddData"
                :dialogLeaveBillVisible="dialogLeaveBillVisible"
                :editItem="editItem"
                :title="title"
                @dialogLeaveBillClose="dialogLeaveBillClose"
            ></dialog-leaveBill>

            <dialog-leaveBillPic
                v-if="dialogLeaveBillPicVisible"
                :dialogLeaveBillPicVisible="dialogLeaveBillPicVisible"
                :param="param"
                :title="title"
                @dialogLeaveBillPicClose="dialogLeaveBillPicClose"
            ></dialog-leaveBillPic>
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogLeaveBill from './components/dialogLeaveBill.vue';
import dialogLeaveBillPic from './components/dialogLeaveBillPic.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-leaveBill': dialogLeaveBill,
        'dialog-leaveBillPic': dialogLeaveBillPic
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery();
    },
    // 定义数据
    data() {
        return {
            columns: [
                {
                    prop: 'processDefinitionName',
                    label: this.$t('pgCommon.WORK_FLOW_CAPTION'),
                    align: 'center',
                    tableWidth: '150'
                },
                {
                    prop: 'startUserId',
                    align: 'center',
                    label: this.$t('pgCommon.START_PERSON')
                },
                {
                    prop: 'startTime',
                    label: this.$t('pgCommon.CREATE_TIME'),
                    align: 'center',
                    tableWidth: '250'
                },
                {
                    prop: 'processInstanceId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'center',
                    tableWidth: '250'
                },
                {
                    prop: 'processDefinitionVersion',
                    label: this.$t('pgCommon.VERSION'),
                    align: 'center',
                    tableWidth: '250'
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.CHECK')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.show(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.WORK_FLOW_PIC')
                            )
                        ]);
                    }
                }
            ],
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            permissionsAdd: ['workflow:add'],
            tableData: [],
            rowKey: 'id',
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            editItem: '',
            param: '',
            loading: false, // 按钮是否为加载状态
            dialogLeaveBillVisible: false,
            dialogLeaveBillPicVisible: false
        };
    },
    // 方法的实现
    methods: {
        // 添加
        btnAdd() {
            this.title = this.$t('pgCommon.WORK_FLOW_TEST');
            this.isAddData = true;
            this.dialogLeaveBillVisible = true;
        },
        // 查看流程图
        show(row) {
            this.param = row;
            this.title = this.$t('pgCommon.WORK_FLOW_TEST');
            this.isAddData = true;
            this.dialogLeaveBillPicVisible = true;
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            let param = {
                userName: sessionStorage.getItem('username'),
                roles: sessionStorage.getItem('roles'),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.queryMyLeaveBill(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.$log.error('/LeaveBill/queryMyLeaveBill', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogLeaveBillVisible = true;
            this.sIdDisabled = true;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 关闭页面
        dialogLeaveBillClose() {
            this.dialogLeaveBillVisible = false;
        },
        // 关闭页面
        dialogLeaveBillPicClose() {
            this.dialogLeaveBillPicVisible = false;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    margin-left: 100px;
}
</style>
